import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { PAGE_TYPES } from 'tradera/hooks/use-page-meta';
import type { InitData } from 'tradera/state/init-data/types';

export type CustomPageMetaData = {
    breadcrumbs: string;
    canonicalLink: string;
    metaDescription: string;
    metaRobots: string;
    ogImage: string;
};

export type PageState = {
    type: string;
    metaTitle: string;
} & CustomPageMetaData;

export const initialState: PageState = {
    type: PAGE_TYPES.DEFAULT,
    metaTitle: '',
    breadcrumbs: '',
    canonicalLink: '',
    metaDescription: '',
    metaRobots: '',
    ogImage: '',
};

const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        initialize: (_, { payload }: PayloadAction<InitData>) => {
            return {
                ...initialState,
                metaDescription: payload.description || '',
                metaTitle: payload.title || '',
                type: payload.pageName,
            };
        },
        setPageMeta: (state, { payload }: PayloadAction<PageState>) => {
            return { ...state, ...payload };
        },
        setPageType: (state, { payload }: PayloadAction<string>) => {
            return { ...state, type: payload };
        },
    },
});

export const { initialize, setPageMeta, setPageType } = pageSlice.actions;

export const reducer = pageSlice.reducer;
